(function () {
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const CFG = window.DT_CFG || {};
const money = c => '$' + (c / 100).toFixed(2);
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
const DT = window.DT = { money };
DT.toBuy = () => { const b = document.getElementById('buy'); if (!b) return; if (window.DT_LENIS) window.DT_LENIS.scrollTo(b, { duration: 1.6 }); else b.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); };

/* ---------- header ---------- */
const top = $('#top');
function onTopScroll() {
  let solid = scrollY > 20;
  if (document.body.classList.contains('roll')) { const sc = $('#scroll'); solid = sc ? scrollY > sc.offsetHeight - innerHeight * .5 : solid; }
  top && top.classList.toggle('solid', solid);
  const pr = $('#prog'); if (pr) pr.classList.toggle('off', solid);
}
addEventListener('scroll', onTopScroll, { passive: true }); onTopScroll();

/* ---------- accordions ---------- */
document.addEventListener('click', e => {
  const q = e.target.closest('.acc-q'); if (!q) return;
  const i = q.parentElement; i.classList.toggle('open'); q.setAttribute('aria-expanded', i.classList.contains('open'));
});

/* ---------- three.js (lazy) ---------- */
let threeP = null;
DT.three = () => threeP || (threeP = new Promise(res => {
  if (window.THREE) return res();
  const s = document.createElement('script'); s.src = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  s.onload = res; s.onerror = res; document.head.appendChild(s);
}));
let ST;
DT.mount = (el, id) => DT.three().then(() => { if (!window.THREE || !window.DTStudio) return; if (ST === undefined) ST = window.DTStudio(); if (ST) ST.mount(el, id); });

/* ---------- cart ---------- */
const dr = $('#dr');
const SP = window.DT_SP || null;
const spOff = () => { try { return localStorage.getItem('dt_sp_off') === '1'; } catch (e) { return false; } };
const setSpOff = v => { try { localStorage.setItem('dt_sp_off', v ? '1' : '0'); } catch (e) {} };
let cart = null, spBusy = false;
const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
const spLine = () => SP && cart ? cart.items.findIndex(i => i.variant_id === SP.id) : -1;
const PR = () => CFG.priority || null;
const prLine = () => PR() && cart ? cart.items.findIndex(i => i.variant_id === PR().id) : -1;
const isExtra = it => (SP && it.variant_id === SP.id) || (PR() && it.variant_id === PR().id);
async function syncSP() {
  // shipping protection follows the cart: auto-add when there are products, drop it when the cart is empty
  if (!SP || spBusy || !cart) return false;
  const idx = spLine(), products = cart.items.filter(i => !isExtra(i)).length, pi = prLine();
    if (pi > -1 && !products) { await post('/cart/change.js', { line: pi + 1, quantity: 0 }); return true; }
  spBusy = true;
  try {
    if (idx > -1 && !products) { await post('/cart/change.js', { line: idx + 1, quantity: 0 }); return true; }
    if (idx > -1 && cart.items[idx].quantity > 1) { await post('/cart/change.js', { line: idx + 1, quantity: 1 }); return true; }
    if (idx < 0 && products && SP.auto && !spOff()) { await post('/cart/add.js', { items: [{ id: SP.id, quantity: 1 }] }); return true; }
  } finally { spBusy = false; }
  return false;
}
async function getCart() {
  cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
  if (await syncSP()) cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
  paint(); return cart;
}
DT.open = () => { window.DT_LENIS && window.DT_LENIS.stop(); document.body.classList.add('dr-open'); dr && dr.setAttribute('aria-hidden', 'false'); setTimeout(() => $('.dr-x') && $('.dr-x').focus(), 50); };
DT.close = () => { window.DT_LENIS && window.DT_LENIS.start(); document.body.classList.remove('dr-open'); dr && dr.setAttribute('aria-hidden', 'true'); };
DT.add = async items => {
  if (SP && SP.auto && !spOff() && spLine() < 0 && !items.some(i => i.id === SP.id)) items = items.concat([{ id: SP.id, quantity: 1 }]);
  const r = await post('/cart/add.js', { items });
  if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || j.message || 'Could not add to cart'); }
  await getCart(); DT.open();
};
async function change(line, quantity) {
  await post('/cart/change.js', { line, quantity });
  await getCart();
}
function paint() {
  const spi = spLine(), spItem = spi > -1 ? cart.items[spi] : null;
  const pri = prLine(), prItem = pri > -1 ? cart.items[pri] : null;
  const count = cart.item_count - (spItem ? spItem.quantity : 0) - (prItem ? prItem.quantity : 0);
  $$('.cc').forEach(c => { c.textContent = count; c.dataset.n = count; });
  if (!dr) return;
  const fs = CFG.freeShip || 0, body = $('.dr-b', dr), foot = $('.dr-f', dr), ship = $('.ship', dr);
  const sub = cart.total_price - (spItem ? spItem.final_line_price : 0) - (prItem ? prItem.final_line_price : 0);
  if (fs && ship) {
    const left = fs - sub;
    ship.style.display = count ? '' : 'none';
    $('.ship-t', ship).innerHTML = left > 0 ? `You're <b>${money(left)}</b> away from free shipping` : `<b>You've unlocked free shipping</b> 🎉`;
    $('.pbar i', ship).style.width = Math.min(100, sub / fs * 100) + '%';
  } else if (ship) ship.style.display = 'none';
  if (!count) {
    body.innerHTML = `<div class="dr-empty"><p>Your cart is empty.</p><a class="btn btn-navy" href="${CFG.rollUrl || '/collections/all'}">Shop the roll</a></div>`;
    foot.style.display = 'none'; return;
  }
  foot.style.display = '';
  const inCart = new Set(cart.items.map(i => i.variant_id));
  body.innerHTML = cart.items.map((it, i) => isExtra(it) ? '' : `<div class="li">
    <img src="${it.image ? it.image + (it.image.includes('?') ? '&' : '?') + 'width=160' : ''}" alt="">
    <div><div class="n">${it.product_title}</div>${it.selling_plan_allocation ? `<div class="sp">↻ ${it.selling_plan_allocation.selling_plan.name}</div>` : ''}
      <div class="q"><button aria-label="Decrease" data-l="${i + 1}" data-q="${it.quantity - 1}">−</button><span>${it.quantity}</span><button aria-label="Increase" data-l="${i + 1}" data-q="${it.quantity + 1}">+</button></div></div>
    <div class="p">${money(it.final_line_price)}${it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : ''}<button class="rm" data-l="${i + 1}" data-q="0">Remove</button></div></div>`).join('')
    + upsells(inCart);
  const disc = cart.items.reduce((a, it) => a + (it.original_line_price - it.final_line_price), 0);
  $('.row2.disc', foot).style.display = disc > 0 ? '' : 'none';
  $('.row2.disc span:last-child', foot).textContent = '−' + money(disc);
  $('.row2.tot span:last-child', foot).textContent = money(cart.total_price);
  const prRow = $('.spx[data-k="pp"]', foot);
  if (prRow) { prRow.hidden = !PR(); if (PR()) { $('.spx-p', prRow).textContent = money(PR().price); $('.dtsw', prRow).setAttribute('aria-checked', prItem ? 'true' : 'false'); const lb = $('.st8', prRow); lb.textContent = prItem ? 'ON' : 'OFF'; lb.classList.toggle('on', !!prItem); } }
  const spRow = $('.spx[data-k="sp"]', foot);
  if (spRow) {
    spRow.hidden = !SP;
    if (SP) { $('.spx-p', spRow).textContent = money(SP.price); $('.dtsw', spRow).setAttribute('aria-checked', spItem ? 'true' : 'false'); const lb = $('.st8', spRow); lb.textContent = spItem ? 'ON' : 'OFF'; lb.classList.toggle('on', !!spItem); }
  }
}
function upsells(inCart) {
  const list = (CFG.upsell || []).filter(p => p.avail && !inCart.has(p.id)).slice(0, 2);
  if (!list.length) return '';
  return `<div class="dr-up"><h3>Complete your routine</h3>${list.map(p => `<div class="up"><img src="${p.img}" alt=""><div><b>${p.title}</b>${p.note ? p.note + ' · ' : ''}${money(p.price)}</div><button data-up="${p.id}">Add</button></div>`).join('')}</div>`;
}
if (dr) {
  dr.addEventListener('click', async e => {
    const b = e.target.closest('[data-l]'); if (b) { b.disabled = true; await change(+b.dataset.l, +b.dataset.q); return; }
    const u = e.target.closest('[data-up]'); if (u) { u.disabled = true; u.textContent = '…'; await DT.add([{ id: +u.dataset.up, quantity: 1 }]); return; }
    const sw = e.target.closest('.dtsw'); const X = sw && (sw.dataset.k === 'pp' ? PR() : SP); if (sw && X) {
      sw.disabled = true; const on = sw.getAttribute('aria-checked') !== 'true';
      if (X === SP) setSpOff(!on);
      const idx = X === SP ? spLine() : prLine();
      if (on && idx < 0) await post('/cart/add.js', { items: [{ id: X.id, quantity: 1 }] });
      if (!on && idx > -1) await post('/cart/change.js', { line: idx + 1, quantity: 0 });
      await getCart(); sw.disabled = false;
    }
  });
  $$('.dr-x,.dr-ov').forEach(x => x.addEventListener('click', DT.close));
  addEventListener('keydown', e => { if (e.key === 'Escape') { DT.close(); document.body.classList.remove('mnav-open'); } });
}
$$('[data-open-cart]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); DT.open(); }));
getCart();

/* ---------- mobile menu ---------- */
const mb = $('.menu-btn'), mn = $('#mnav');
if (mb && mn) {
  const set = o => { if (window.DT_LENIS) o ? window.DT_LENIS.stop() : window.DT_LENIS.start(); document.body.classList.toggle('mnav-open', o); mb.setAttribute('aria-expanded', o); };
  mb.addEventListener('click', () => set(true));
  $('.mx', mn).addEventListener('click', () => set(false));
  mn.addEventListener('click', e => { if (e.target.closest('a')) set(false); });
}

/* ---------- reveal on scroll ---------- */
if ('IntersectionObserver' in window) {
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
  $$('.stg').forEach(el => [...el.children].forEach((c, i) => { c.style.transitionDelay = Math.min(i * 70, 420) + 'ms'; }));
  $$('.rv, .stg').forEach(el => io.observe(el));
} else $$('.rv, .stg').forEach(el => el.classList.add('in'));

/* ---------- buy box ---------- */
function initBB(root) {
  const c = JSON.parse($('script[type="application/json"]', root).textContent);
  const P = c.products, st = { tier: c.defTier || 0, sub: c.sub !== false && !!P[c.main].plan, prio: false, addon: false };
  const lineP = (k, sub) => (sub && P[k].sub != null ? P[k].sub : P[k].price);
  function totals(tier, sub) {
    const t = c.tiers[tier]; let now = 0, was = 0;
    // Shopify rounds percentage discounts down per unit, so mirror that to match checkout to the cent
    t.items.forEach(([k, q]) => { const u = lineP(k, sub); now += (u - Math.floor(u * (t.pct || 0) / 100)) * q; was += Math.max(P[k].compare, P[k].price) * q; });
    return { now, was };
  }
  function render() {
    $$('[data-tier]', root).forEach(el => {
      const i = +el.dataset.tier, t = totals(i, st.sub), n = c.tiers[i].items.reduce((a, [, q]) => a + q, 0);
      el.classList.toggle('sel', i === st.tier); $('input', el).checked = i === st.tier;
      $('.pz strong', el).textContent = money(t.now);
      $('.pz s', el).textContent = t.was > t.now ? money(t.was) : '';
      const em = $('.pz em', el); if (em) em.textContent = n > 1 ? money(Math.round(t.now / n)) + ' each' : '';
      const sv = $('[data-save]', el); if (sv) { const p = Math.round((1 - t.now / t.was) * 100); sv.textContent = p > 0 ? `You save ${money(t.was - t.now)} (${p}%)` : ''; }
    });
    $$('[data-sub]', root).forEach(el => {
      const on = el.dataset.sub === '1'; el.classList.toggle('sel', on === st.sub); $('input', el).checked = on === st.sub;
      const t = totals(st.tier, on); $('.pz strong', el).textContent = money(t.now); $('.pz s', el).textContent = t.was > t.now ? money(t.was) : '';
    });
    const t = totals(st.tier, st.sub);
    let total = t.now + (st.prio && c.priority ? c.priority.price : 0) + (st.addon && c.addon ? lineP(c.addon, st.sub) : 0);
    $$('.ap', root).forEach(a => a.textContent = '· ' + money(total));
    $$('[data-price-now]').forEach(a => a.textContent = money(t.now));
    $$('[data-price-was]').forEach(a => a.textContent = t.was > t.now ? money(t.was) : '');
    $$('[data-price-save]').forEach(a => { const p = Math.round((1 - t.now / t.was) * 100); a.textContent = p > 0 ? `Save ${p}%` : ''; a.style.display = p > 0 ? '' : 'none'; });
    $$('.sbar [data-sbar-price]').forEach(a => a.textContent = money(total) + (st.sub ? ' · Subscribe & save' : ''));
    const dyn = $('[data-dyn]', root);
    if (dyn) {
      const items = c.tiers[st.tier].items, single = items.length === 1 && !st.addon && !st.prio;
      dyn.hidden = !single;
      const qf = $('input[name="quantity"]', dyn), sp = $('input[name="selling_plan"]', dyn);
      if (qf) qf.value = items[0][1];
      if (sp) sp.disabled = !st.sub;
    }
  }
  root.addEventListener('change', e => {
    const i = e.target;
    if (i.name === 'tier') st.tier = +i.value;
    if (i.name === 'sub') st.sub = i.value === '1';
    if (i.name === 'prio') st.prio = i.checked;
    if (i.name === 'addon') st.addon = i.checked;
    render();
  });
  async function add(btn) {
    const items = [], plan = k => (st.sub && P[k].plan ? { selling_plan: P[k].plan } : {});
    c.tiers[st.tier].items.forEach(([k, q]) => items.push({ id: P[k].id, quantity: q, ...plan(k), ...(c.tiers[st.tier].prop ? { properties: { _bundle: c.tiers[st.tier].prop } } : {}) }));
    if (st.addon && c.addon) items.push({ id: P[c.addon].id, quantity: 1, ...plan(c.addon) });
    if (st.prio && c.priority) items.push({ id: c.priority.id, quantity: 1 });
    const err = $('.bb-err', root); err.classList.remove('on');
    const b = btn || $('.atc', root); const old = b.innerHTML; b.disabled = true; b.innerHTML = 'Adding…';
    try { await DT.add(items); if (window.fbq) fbq('track', 'AddToCart', { value: totals(st.tier, st.sub).now / 100, currency: 'USD' }); }
    catch (x) { err.textContent = x.message; err.classList.add('on'); }
    b.disabled = false; b.innerHTML = old; render();
  }
  $('.atc', root).addEventListener('click', () => add());
  root.__add = add;
  render();
  return root;
}
const bbs = $$('[data-bb]').map(initBB);

/* ---------- sticky bar ---------- */
const sbar = $('.sbar');
if (sbar && bbs[0]) {
  const atc = $('.atc', bbs[0]); let atcVisible = false;
  new IntersectionObserver(([e]) => { atcVisible = e.isIntersecting || e.boundingClientRect.top > innerHeight; upd(); }).observe(atc);
  const isRoll = document.body.classList.contains('roll');
  function upd() {
    let show;
    if (isRoll) { const r = $('#buy').getBoundingClientRect(); show = scrollY > innerHeight * .4 && !(r.top < innerHeight * .8 && atc.getBoundingClientRect().bottom > 0); }
    else show = !atcVisible && atc.getBoundingClientRect().bottom < 0;
    sbar.classList.toggle('on', !!show);
    const sk = $('.skip'); if (sk) sk.classList.toggle('off', !!show || scrollY > ($('#scroll') ? $('#scroll').offsetHeight - innerHeight * 1.2 : 0));
  }
  addEventListener('scroll', upd, { passive: true }); upd();
  $('.sbar .btn').addEventListener('click', e => {
    if (isRoll) { e.preventDefault(); DT.toBuy(); return; }
    bbs[0].__add(e.currentTarget);
  });
}
$$('a[href="#buy"]').forEach(a => a.addEventListener('click', e => { const b = $('#buy'); if (!b) return; e.preventDefault(); DT.toBuy(); }));

/* ---------- gallery ---------- */
$$('[data-gal]').forEach(g => {
  const main = $('.gmain', g), imgs = $$('.gmain>img', g); let mounted = false;
  $$('.gthumbs button', g).forEach(b => b.addEventListener('click', () => {
    $$('.gthumbs button', g).forEach(x => x.setAttribute('aria-current', x === b));
    if (b.dataset.i === '3d') { main.classList.add('is3d'); if (!mounted) { mounted = true; DT.mount($('.vslot', main), main.dataset.model); } return; }
    main.classList.remove('is3d'); imgs.forEach((im, i) => im.classList.toggle('on', i === +b.dataset.i));
  }));
  let x0 = null; main.addEventListener('touchstart', e => { if (!main.classList.contains('is3d')) x0 = e.touches[0].clientX; }, { passive: true });
  main.addEventListener('touchend', e => { if (x0 == null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) < 40) return;
    const btns = $$('.gthumbs button', g), cur = btns.findIndex(b => b.getAttribute('aria-current') === 'true'); const n = btns[Math.max(0, Math.min(btns.length - 1, cur + (dx < 0 ? 1 : -1)))]; n && n.click(); });
});
/* home hero / standalone 3D slots */
$$('.vslot[data-autoload]').forEach(el => {
  const go = () => DT.mount(el, el.dataset.model);
  if ('IntersectionObserver' in window) { const o = new IntersectionObserver(([e]) => { if (e.isIntersecting) { o.disconnect(); go(); } }); o.observe(el); } else go();
});

/* ---------- collection filter + sort ---------- */
const shop = $('[data-shop]');
if (shop) {
  const grid = $('[data-grid="shop"]', shop), cards = $$('.pc', grid); let filt = 'All';
  function draw() {
    const s = $('#sort').value;
    let list = cards.filter(c => filt === 'All' || c.dataset.cat === filt);
    if (s === 'lo') list.sort((a, b) => a.dataset.price - b.dataset.price);
    if (s === 'hi') list.sort((a, b) => b.dataset.price - a.dataset.price);
    if (s === 'save') list.sort((a, b) => b.dataset.save - a.dataset.save);
    cards.forEach(c => c.hidden = !list.includes(c)); list.forEach(c => grid.appendChild(c));
    $('#count').textContent = list.length + (list.length === 1 ? ' product' : ' products');
  }
  $('.chips', shop).addEventListener('click', e => { const b = e.target.closest('[data-f]'); if (!b) return; filt = b.dataset.f; $$('.chips button', shop).forEach(x => x.setAttribute('aria-pressed', x === b)); draw(); });
  $('#sort').onchange = draw; draw();
}
})();
